import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import Register from './views/Register.vue'
import Quotation from './views/Quotation.vue'
import Packages from './views/Packages.vue'
import Bills from './views/Bills.vue'
import Contact from './views/Contact.vue'
import TaxReturn from './views/TaxReturn.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/client',
      name: 'client',
      component: Login,
      meta: {auth: false}
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      props: true,
      meta: {auth: true}
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {auth: false}
    },
    {
      path: '/calcule-o-cotice-sus-costos-de-envio',
      name: 'Quotation',
      component: Quotation,
      meta: {auth: false}
    },
     {
      path: '/calcular-costo',
      name: 'Quotation',
      component: Quotation,
      meta: {auth: false}
    },
    {
      path: '/packages',
      name: 'Packages',
      component: Packages,
      meta: {auth: true}
    },
    {
      path: '/tax-return',
      name: 'TaxReturn',
      component: TaxReturn,
      meta: {auth: true}
    },
    {
      path: '/bills',
      name: 'Bills',
      component: Bills,
      meta: {auth: true}
    },
    {
      path: '/contactenos',
      name: 'Contact',
      component: Contact,
      meta: {auth: false}
    },
    {
      path: '/servicios',
      name: 'Contact',
      component: Contact,
      meta: {auth: false}
    }
  ]
})

